export const invite = {
  fuwutiaokuan: '《Termos de Serviço》',
  yinsizhengce: '《Política de Privacidade》',
  fzcg: 'Copiado com sucesso',
  yqhy: "convide amigos",
  fxlj: "compartilhar link",
  register_now: 'Registrar Agora',
  phone: 'Celular',
  email: 'E-mail',
  placehold_phone: 'Digite seu número de celular',
  placehold_email: 'Digite seu e-mail',
  placehold_code: 'código de convite',
  argee: 'Eu li e concordo com',
  agreement: 'o Contrato do Usuário da BiKing',
  register: 'Registrar',
  phone_code: 'Código de Verificação (SMS)',
  email_code: 'Código de Verificação (E-mail)',
  code_to_phone: 'O código de verificação foi enviado por SMS para o seu celular',
  code_to_email: 'O código de verificação foi enviado para o seu e-mail',
  has_sent: 'Código de verificação enviado para:',
  resend: 'Reenviar',
  send_code: 'Enviar Código de Verificação',
  unable_code: 'Não recebeu o código de verificação?',
  set_pwd: 'Definir Senha',
  placehold_pwd: 'Digite sua senha',
  submit: 'Enviar',
  error_phone: 'Por favor, insira um número de celular correto',
  error_email: 'Formato de e-mail incorreto, por favor, insira novamente',
  error_checked: 'Por favor, marque o contrato antes de prosseguir',
  text: 'Formato de senha incorreto. A senha deve ter entre 8 e 32 caracteres e incluir letras maiúsculas, minúsculas e números.',
  validate: 'Por favor, complete a verificação',
  register_success: 'Registro bem-sucedido!',
  welcome: 'Bem-vindo à BiKing',
  start_trade: 'Deposite criptomoedas e comece a negociar',
  safe: 'Múltiplas opções de depósito para negociar criptomoedas de forma segura e conveniente',
  pay_type: 'Compre e venda criptomoedas através de cartões bancários ou outros métodos de pagamento',
  right_now_download: 'Faça o download agora',
  right_download: 'Faça o download',
  'Please_enter_correct_phone_number': 'Por favor, digite um número de celular correto',
  'Referral_code': 'Digite o seu código de convite',
  'I_have_read_and_agree': 'Eu li e concordo com',
  'BiKing_User_Agreement': 'o Contrato do Usuário da BiKing',
  'Please_enter_password': 'Digite sua senha',
  'Email_verification_code': 'Código de Verificação (E-mail)',
  'SMS_code': 'Código de Verificação (SMS)',
  'Incorrect_email_format_please_reenter': 'Formato de e-mail incorreto, por favor, insira novamente',
  'Please_read_and_agree_User_Agreement': 'Por favor, leia e concorde com o Contrato do Usuário',
  'Sent_code_to': 'Código de verificação enviado para'
};



// WEBPACK FOOTER //
// ./src/i18n/lang/invite/pt_BR.js